import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_ROLLE_BENUTZER_ENTFERNEN_MULTI = '[BenutzerverwaltungModul] PostRolleBenutzerEntfernenMulti laden';
export const POST_ROLLE_BENUTZER_ENTFERNEN_MULTI_AUSFUEHREN = '[BenutzerverwaltungModul] PostRolleBenutzerEntfernenMulti ausführen';
export const POST_ROLLE_BENUTZER_ENTFERNEN_MULTI_ERFOLGREICH = '[BenutzerverwaltungModul] PostRolleBenutzerEntfernenMulti laden erfolgreich';
export const POST_ROLLE_BENUTZER_ENTFERNEN_MULTI_FEHLER = '[BenutzerverwaltungModul] PostRolleBenutzerEntfernenMulti Ladefehler';
export const POST_ROLLE_BENUTZER_ENTFERNEN_MULTI_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostRolleBenutzerEntfernenMulti nicht ausgeführt (evtl. Offline)';


export class PostRolleBenutzerEntfernenMultiAction implements Action {
    readonly type = POST_ROLLE_BENUTZER_ENTFERNEN_MULTI;
        constructor(public rolleBenutzerMultiRequest: api.RolleBenutzerMultiRequest, public optPayload: any = null) {}
    }
export class PostRolleBenutzerEntfernenMultiAusfuehrenAction implements Action {
    readonly type = POST_ROLLE_BENUTZER_ENTFERNEN_MULTI_AUSFUEHREN;
        constructor(public rolleBenutzerMultiRequest: api.RolleBenutzerMultiRequest, public optPayload: any = null) {}
    }
export class PostRolleBenutzerEntfernenMultiErfolgreichAction implements Action {
    readonly type = POST_ROLLE_BENUTZER_ENTFERNEN_MULTI_ERFOLGREICH;
        constructor(public payload: api.RolleIdentifier, public rolleBenutzerMultiRequest: api.RolleBenutzerMultiRequest, public optPayload: any = null) {}
    }
export class PostRolleBenutzerEntfernenMultiFehlerAction implements Action {
    readonly type = POST_ROLLE_BENUTZER_ENTFERNEN_MULTI_FEHLER;
        constructor(public payload: any, public rolleBenutzerMultiRequest: api.RolleBenutzerMultiRequest, public optPayload: any = null) {}
    }
export class PostRolleBenutzerEntfernenMultiNichtAusgefuehrtAction implements Action {
    readonly type = POST_ROLLE_BENUTZER_ENTFERNEN_MULTI_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandRolleBenutzerEntfernenMultiActions =
    PostRolleBenutzerEntfernenMultiAction
    | PostRolleBenutzerEntfernenMultiAusfuehrenAction
    | PostRolleBenutzerEntfernenMultiErfolgreichAction
    | PostRolleBenutzerEntfernenMultiFehlerAction
    | PostRolleBenutzerEntfernenMultiNichtAusgefuehrtAction
    ;
